export function adjustedRestDeadline(currentEnd: number | undefined, deltaSeconds: number, now = Date.now()): number | undefined {
  if (!currentEnd || currentEnd <= now) return deltaSeconds > 0 ? now + deltaSeconds * 1000 : undefined;
  return Math.max(now + 1000, currentEnd + deltaSeconds * 1000);
}

export function restAlarmDue(end: number | undefined, playedFor: number, now = Date.now()): boolean {
  return Boolean(end && end <= now && playedFor !== end);
}
